import React from "react";
import "./Submenu.scss";
import {useLocation} from "react-router-dom";
import classNames from "classnames";
import {routeCodes} from "@constants/routes";

function Submenu(props) {
  const location = useLocation();
  const isActive = (value) => {
    if (location.pathname === value) return true;

    // eslint-disable-next-line no-unused-vars
    const [slash, firstPath] = location.pathname?.split("/");
    // eslint-disable-next-line no-unused-vars
    const [routeSlash, routeFirstPath] = value?.split("/");

    return firstPath === routeFirstPath;
  };

  return (
    <div className="submenu">
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 navigation-left" />

        <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <ul className="submenu-list">
            <li
              className={classNames({
                active: isActive(routeCodes.NAVEGACAO),
              })}
            >
              <a href={routeCodes.NAVEGACAO}>Navegação</a>
            </li>
            <li
              className={classNames({
                active: isActive(routeCodes.SEARCH),
              })}
            >
              <a href={routeCodes.SEARCH}>Buscar termos</a>
            </li>
            <li
              className={classNames({
                active: isActive(routeCodes.ALERTAS),
                "small-only": true,
              })}
            >
              <a href={routeCodes.ALERTAS}>Alertas</a>
            </li>
            <li
              className={classNames({
                active: isActive(routeCodes.ALERTAS),
                "large-only": true,
              })}
            >
              <a href={routeCodes.ALERTAS}>Cadastro de Alertas</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default Submenu;
